var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_x0020_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.367,
    height: 31.367,
    viewBox: "0 0 31.367 31.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M15.683,0A15.683,15.683,0,1,1,0,15.683,15.683,15.683,0,0,1,15.683,0Zm-2.03,23.3a.2.2,0,0,0,.2.2h2.806a.2.2,0,0,0,.2-.2V15.621h2.035a.2.2,0,0,0,.2-.18l.2-2.313a.2.2,0,0,0-.2-.214h-2.23V11.273a.7.7,0,0,1,.7-.7h1.568a.2.2,0,0,0,.2-.2V8.066a.2.2,0,0,0-.2-.2H16.468a2.815,2.815,0,0,0-2.815,2.814v2.231h-1.4a.2.2,0,0,0-.2.2v2.313a.2.2,0,0,0,.2.2h1.4Z",
    fill: "#74767d",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.203d8b21d9ac2e591ab61f2abe7cf591.svg";
export { ForwardRef as ReactComponent };